export default{
    actions: {
        alert({commit}, value){
            commit('setAlert', value);
        }
    },

    mutations: {
        setAlert(state, payload){
            state.alert.show = true;
            state.alert.type = payload.type;
            state.alert.message = payload.message;
            setTimeout(() => {
                state.alert.show = false;
            }, 10000);
        }
    },

    state: {
        alert: {
            type: null,
            message: '',
            show: false,
        },
    },

    getters: {
        ALERT(state){
            return state.alert;
        }
    }
}